import { useEffect, useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import { POS_CONFIG } from 'state/posConfig/type';
import usePosConfig from 'state/posConfig/hooks/usePosConfig';

interface IProps {
  selectedProvider: POS_CONFIG.IEnabledProviders | undefined;
  onSelectProvider: (provider: POS_CONFIG.IEnabledProviders) => void;
}

const POSProviderDropdown = ({
  selectedProvider,
  onSelectProvider,
}: IProps) => {
  const { posConfig } = usePosConfig();
  const { enabledProviders } = posConfig;

  const [posProviderOptions, setPosProviderOptions] = useState<
    POS_CONFIG.IEnabledProviders[]
  >([]);

  useEffect(() => {
    if (enabledProviders?.data && Array.isArray(enabledProviders.data)) {
      setPosProviderOptions(enabledProviders.data);
    } else {
      setPosProviderOptions([]);
    }
  }, [enabledProviders]);

  const handleValueChange = (value: string) => {
    const provider = posProviderOptions.find((p) => p.name === value);
    if (provider) onSelectProvider(provider);
  };

  return (
    <>
      <div className="flex flex-col gap-3 mt-8">
        <span className="font-semibold text-gray-blue-80">POS provider</span>
        <span className="text-sm font-medium leading-5 text-gray-blue-80">
          Select provider
        </span>
      </div>

      <div className="w-81 mt-2 mb-3">
        <Select value={selectedProvider?.name} onValueChange={handleValueChange}>
          <SelectTrigger
            data-testid="pos_provider_dropdown"
            className="h-9 text-sm font-normal"
          >
            <SelectValue placeholder="Please select" />
          </SelectTrigger>
          <SelectContent>
            {posProviderOptions
              ?.filter((item): item is POS_CONFIG.IEnabledProviders & { name: string } => {
                if (!item.name) {
                  // eslint-disable-next-line no-console
                  console.warn('POSProviderDropdown: dropping enabled provider without a name', item);
                  return false;
                }
                return true;
              })
              .map((item) => (
                <SelectItem key={item.name} value={item.name}>
                  {item.name}
                </SelectItem>
              ))}
          </SelectContent>
        </Select>
      </div>
    </>
  );
};

export default POSProviderDropdown;
